const IS_BROWSER = typeof window !== "undefined";
const GTAG_ID = "G-430EPZZG3B";
const DATA_LAYER = "shplnDataLayer";

const UNKNOWN_SHOPIFY: Window["Shopify"] = {
    shop: "unknown",
    theme: { role: "development", id: -1, name: "Theme" },
};

const shopHandle = () => {
    if (typeof window === "undefined" || window.Shopify == null) {
        return UNKNOWN_SHOPIFY.shop;
    }
    return window.Shopify.shop.replace(/.myshopify.com/, "");
};

const dryRun = () => {
    if (typeof window === "undefined" || window.Shopify == null) {
        return true;
    }

    return window.Shopify.theme.role !== "main";
};

if (IS_BROWSER) {
    const scriptTag = document.createElement("script");
    scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}&l=${DATA_LAYER}`;
    scriptTag.setAttribute("id", "shpln-gtag");

    document.querySelector("head")?.prepend(scriptTag);

    window[DATA_LAYER] = window[DATA_LAYER] || [];

    if (window.shplnGtag == null) {
        window.shplnGtag = function () {
            window[DATA_LAYER].push(arguments);
        };
        window.shplnGtag("js", new Date());
        window.shplnGtag("config", GTAG_ID);
    }
} else {
    console.error(
        "[shpln-quiz] Current environment is not browser. Tracking will be disabled.",
    );
}

export function logEvent(action: string, data: any = {}) {
    console.log(`[shpln-quiz][event] ${action}`, data, shopHandle());

    if (!IS_BROWSER || dryRun()) {
        return;
    }

    data.timestamp = Date.now();
    data.shop = shopHandle();

    window.shplnGtag("event", action, data);
}

export default { logEvent };
